import { Fragment } from 'react'
import { Popover, Transition } from '@headlessui/react'
import logo from "../assets/images/logo.png"
import {
    ChartBarIcon,
    CursorClickIcon,
    MenuIcon,
    RefreshIcon,
    ShieldCheckIcon,
    ViewGridIcon,
    XIcon,
    ChevronRightIcon,
} from '@heroicons/react/outline'
import {Link, NavLink} from "react-router-dom";

const solutions = [
    {
        name: 'Inicio',
        href: '/',
        icon: ChevronRightIcon,
    },
    {
        name: 'Nosotros',
        description: 'Speak directly to your customers in a more meaningful way.',
        href: 'nosotros',
        icon: ChevronRightIcon,
    },
    {
        name: 'Eventos',
        description: "Your customers' data will be safe and secure.",
        href: 'eventos',
        icon: ChevronRightIcon,
    },
    {
        name: 'Recursos',
        description: "Connect with third-party tools that you're already using.",
        href: 'recursos',
        icon: ChevronRightIcon,
    },
    {
        name: 'Adoración',
        description: 'Build strategic funnels that will drive your customers to convert',
        href: 'adoracion',
        icon: ChevronRightIcon,
    },
    {
        name: 'Formación',
        description: 'Build strategic funnels that will drive your customers to convert',
        href: 'formacion',
        icon: ChevronRightIcon,
    },
    {
        name: 'Más Viñas',
        description: 'Build strategic funnels that will drive your customers to convert',
        href: 'mas-vinas',
        icon: ChevronRightIcon,
    },
    {
        name: 'Jóvenes',
        description: 'Build strategic funnels that will drive your customers to convert',
        href: 'jovenes',
        icon: ChevronRightIcon,
    },
]

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

export default function Example() {
    return (
        <Popover className="relative bg-white z-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6">
                <div className="flex justify-between items-center border-b-2 border-gray-100 py-6 md:justify-start md:space-x-10">
                    <div className="flex justify-start lg:w-0 lg:flex-1">
                        <Link to="/">
                            <span className="sr-only">Iglesias La Viña Chile</span>
                            <img
                                className="sm:h-20"
                                alt="Iglesias La Viña Chile"
                                src={logo}
                            />
                        </Link>
                    </div>
                    <div className="-mr-2 -my-2 md:hidden">
                        <Popover.Button className="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500">
                            <span className="sr-only">Open menu</span>
                            <MenuIcon className="h-6 w-6" aria-hidden="true" />
                        </Popover.Button>
                    </div>
                    <Popover.Group as="nav" className="hidden md:flex space-x-10">

                        <NavLink to={'/'} className="text-base font-medium text-gray-500 hover:text-gray-900">
                            Inicio
                        </NavLink>
                        <NavLink to={'/nosotros'} className="text-base font-medium text-gray-500 hover:text-gray-900">
                            Nosotros
                        </NavLink>
                        <NavLink to={'/eventos'} className="text-base font-medium text-gray-500 hover:text-gray-900">
                            Eventos
                        </NavLink>
                        <NavLink to={'/recursos'} className="text-base font-medium text-gray-500 hover:text-gray-900">
                            Recursos
                        </NavLink>
                        <NavLink to={'/adoracion'} className="text-base font-medium text-gray-500 hover:text-gray-900">
                            Adoración
                        </NavLink>
                        <NavLink to={'/formacion'} className="text-base font-medium text-gray-500 hover:text-gray-900">
                            Formación
                        </NavLink>
                        <NavLink to={'/mas-vinas'} className="text-base font-medium text-gray-500 hover:text-gray-900">
                            Más Viñas
                        </NavLink>
                        <NavLink to={'/jovenes'} className="text-base font-medium text-gray-500 hover:text-gray-900">
                            Jóvenes
                        </NavLink>

                    </Popover.Group>
                </div>
            </div>

            <Transition
                as={Fragment}
                enter="duration-200 ease-out"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="duration-100 ease-in"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
            >
                <Popover.Panel focus className="absolute top-0 inset-x-0 p-2 transition transform origin-top-right md:hidden">
                    <div className="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 bg-white divide-y-2 divide-gray-50">
                        <div className="pt-5 pb-6 px-5">
                            <div className="flex items-center justify-between">
                                <div>
                                    <img
                                        className="h-20 w-auto"
                                        src={logo}
                                        alt="Iglesias La Viña Chile"
                                    />
                                </div>
                                <div className="-mr-2">
                                    <Popover.Button className="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500">
                                        <span className="sr-only">Cerrar menu</span>
                                        <XIcon className="h-6 w-6" aria-hidden="true" />
                                    </Popover.Button>
                                </div>
                            </div>
                            <div className="mt-6">
                                <nav className="grid gap-y-8">
                                    {solutions.map((item) => (
                                        <Link
                                            key={item.name}
                                            to={item.href}
                                            className="-m-3 p-3 flex items-center text-orange-200 rounded-md hover:bg-gray-50"
                                        >
                                            <item.icon className="flex-shrink-0 h-6 w-6 text-orange-200" aria-hidden="true" />
                                            <span className="ml-3 text-base font-medium text-gray-900">{item.name}</span>
                                        </Link>
                                    ))}
                                </nav>
                            </div>
                        </div>
                    </div>
                </Popover.Panel>
            </Transition>
        </Popover>
    )
}
